<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin"></div>
    </Transition>

    <v-form>
        <div class="grid">
            <FormFileUploader fieldName="files"
                              :label="__('Select XML file containing bank statements')"
                              labelStyle="font-weight:bold"
                              :maxFiles="1"
                              category="import"
                              style="margin-top:10px"
                              :allowedExtensions="['xml']"
                              v-model:field="fileToImport" />
        </div>

        <div class="grid">
            <Button severity="success"
                    style="margin:0 8px"
                    @click="makeImport"
                    :class="buttonClass('green')">
                <template class="flex items-center gap-1"><i class="fa-solid fa-file-code"></i><span>{{ __('Make import') }}</span></template>
            </Button>
            <Button severity="secondary"
                    style="margin:0 8px"
                    @click="cancelImport"
                    :class="buttonClass('gray')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-trash-can"></i><span>{{ __('Cancel') }}</span></template>
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref } from 'vue'
import { useForm, usePage } from '@inertiajs/vue3'
import FormFileUploader from '@pages/Crud/FormFileUploader.vue'
import Button from 'primevue/button';
import { __, buttonClass, screenMessage } from '@pages/Helper/utils.js'

// -----------------------------------------------------
const props = defineProps({
    formProps: Object,
})

const page = usePage()
const isLoading = ref(false);
const fileToImport = ref([])
const isBankDataImportModalOpen = defineModel('isBankDataImportModalOpen')

// -----------------------------------------------------

const cancelImport = () => {
    isBankDataImportModalOpen.value = false
}
// -----------------------------------------------------

const makeImport = async () => {
    isLoading.value = true
    useForm({ fileToImport: fileToImport.value.import }).post(route('statement-importxml'), {
        preserveState: true,
        preserveScroll: true,
        forceFormData: true,
        onSuccess: () => {
            if (page.props?.flash?.message) {
                screenMessage({ success: true, type: 'success', message: page.props.flash.message })
            }
        },
        onError: (errors) => {
            screenMessage({ success: false, type: 'error', message: errors.fileToImport?.[0] || errors['fileToImport.0'] })
            console.log(errors)
        },
        onFinish: () => {
            props.formProps.getLazyData()
            isLoading.value = false
            isBankDataImportModalOpen.value = false
        }
    })
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
